import { LoadingSpinnerWithImage } from 'Components/designSystem';
import React, { PropsWithChildren, Suspense } from 'react';

export default function LazyConnector({ children }: PropsWithChildren<unknown>) {
    return (
        <Suspense fallback={ <LoadingSpinnerWithImage portal /> }>
            { children }
        </Suspense>
    );
}
